/**
 * @returns {any} 返回 set 或者 get
 */
function cookie() {
	// if arguments.length > 1,set cookie
	if (arguments.length > 1) {
		return cookie.set.apply(this, [].slice.call(arguments));
	}
	return cookie.get.apply(this, [].slice.call(arguments));
}

/**
 * @param {any} key cookie 键名
 * @param {any} value cookie 键值
 * @param {any} attrs cookie attrs
 * @returns {string} ‘key=value’
 */
cookie.set = function (key, value, attrs) {
	if (!key) {
		return false;
	}

	attrs = Object.assign({}, attrs);
	// set expires
	if (typeof attrs.expires === 'number') {
		var expires = new Date();

		expires.setMilliseconds(expires.getMilliseconds() + attrs.expires * 864e5);
		attrs.expires = expires;
	}

	// handle value
	try {
		var result = JSON.stringify(value);

		// object or array
		if (/^[{[]/.test(result)) {
			value = result;
		}
	} catch (e) {
		// console.log(e);
	}

	value = encodeURIComponent(String(value));
	// .replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

	// handle key
	key = encodeURIComponent(String(key))
		.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
		.replace(/[()]/g, escape);

	return [key, '=', value].join('');
};
/**
 * @param {string} cookies 字符串
 * @returns {obejct} end 解析的对象
 */
cookie.parse = function (cookies) {
	cookies = cookies ? cookies.split(';') : [];
	var end = {};

	var item = [];

	var rdecode = /(%[0-9A-Z]{2})+/g;
	try {
		cookies.forEach(function (val) {
			item = val.split('=');
			var _key = item[0].trim().replace(rdecode, decodeURIComponent);
			var _val = item[1].replace(rdecode, decodeURIComponent);
			if (/^"/.test(_val)) {
				_val = _val.slice(1, -1);
			}
			end[_key] = _val || '';
		});
	} catch (e) {
		// console.log(e);
	}

	return end;
};

/**
 * @param {any} cookies 对象
 * @returns {string} cookie 字符串
 */
cookie.genarator = function (cookies) {
	var str = [];
	for (var key in cookies) {
		str.push(cookie.set(key, cookies[key]));
	}

	return str.join('; ');
};

export default cookie;



// WEBPACK FOOTER //
// ./src/lib/cookie.js